<div class="carousel">
    <owl-carousel-o [options]="customOptions">
        <ng-template carouselSlide *ngFor="let image of images; index as i">
            <div class="slide">
                <div class="picsum-img-wrapper">
                    <img src="assets/images/tratamentos/{{image.link}}" alt="{{image.description}}">
                </div>
                <div class="carousel-caption">
                    <h3>{{image.title}}</h3>
                </div>
            </div>
        </ng-template>
    </owl-carousel-o>
</div>